import axios from "axios";
import { getCookie } from "../../getcookie";
// import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
    'Content-Type': 'application/json; charset=UTF-8',
    "Accept": "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    "Authorization": getCookie("mawalog")
}





export const getfielsApi = async (value) => {

    try {
        const response = await axios.get(
            apiUrl + `register_page` + value,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};


export const registerSubmitApi = async (data) => {

    try {
        const response = await axios.post(
            apiUrl + `register_page`, data, { headers: header }).then((response) => {
                return response;
            }).catch((error) => {
                console.log('error...', error.response)
                return error.response;

            });
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getGateListApi = async (term) => {
  try {
    const response = await axios.get(
      apiUrl + "gate/autosuggestion?term="+term,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

export const getDeptListApi = async (term) => {
  try {
    const response = await axios.get(
      adminApiUrl + "get_department?term="+term,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

export const getFieldListApi = async (term) => {
  try {
    const response = await axios.get(
      apiUrl + "register_page/get_pages",
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};


export const getOptionsListApi = async (term) => {
  try {
    const response = await axios.get(
      apiUrl + "register_page/get_fields/"+ term,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

//Edit
export const getEditApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`register_page/get/`+id,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Update
export const UpdateFieldsApi = async (data,id) => {  
  try {
    const response = await axios.put(
      apiUrl+`register_page/`+id,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};